export const AppAction = {
  LogOut: 'USER_LOGOUT'
};
